import React from 'react';
import { useScrollbarWidth } from 'react-use';
import { setAppElement } from '@noths/polaris-client-ribbons-design-system';
import { createGlobalStyle } from 'styled-components';

import { SiteChromeStaticContext } from 'client-site-chrome-ui/context/SiteChromeStaticContext/SiteChromeStaticContext';
import type {
  SiteChromeStaticContextProviderProps,
  SiteChromeStaticContextValue,
} from 'client-site-chrome-ui/context/SiteChromeStaticContext/types';

export const createSiteChromeStaticContextProvider = (appSelector?: string) => {
  const GlobalStyles =
    appSelector &&
    createGlobalStyle<{ scrollBarWidth: number }>`

      .ReactModal__Body--open {
        overflow: hidden;
        padding-right: ${(props) => props.scrollBarWidth}px;
      }
    `;

  return ({
    children,
    compact = false,
    cookies,
    env,
    mergeBasket = true,
    searchedTerm,
    ...props
  }: SiteChromeStaticContextProviderProps) => {
    const staticContextValue: SiteChromeStaticContextValue = {
      compact,
      cookies,
      env,
      searchedTerm,
      mergeBasket,
    };

    if (appSelector) {
      setAppElement(appSelector);
    }
    const scrollBarWidth = useScrollbarWidth();

    return (
      <>
        {GlobalStyles && <GlobalStyles scrollBarWidth={scrollBarWidth || 0} />}
        <SiteChromeStaticContext.Provider value={staticContextValue} {...props}>
          {children}
        </SiteChromeStaticContext.Provider>
      </>
    );
  };
};
